import { getWrapper, wrapper } from '../request';
export var ListThemes = wrapper('themes')('ListThemes');
export var ListMyThemes = getWrapper('themes')('ListMyThemes');
export var GetThemeDetail = getWrapper('themes')('GetThemeDetail');
export var UpdateThemeFont = wrapper('theme')('updateFont');
export var saveConfigProvider = wrapper('theme')('saveConfigProvider');
export var resetConfigProvider = wrapper('theme')('resetConfigProvider');
export var resetConfigProviderKey = wrapper('theme')('resetConfigProviderKey');
export var ConfigThemeFont = wrapper('theme')('configFont');
export var GetThemeDetailNoErrorTip = getWrapper('themes')('GetThemeDetail', {
  messageError: false
});
export var DeleteTheme = wrapper('themes')('DeleteTheme');
export var RestoreTheme = wrapper('themes')('RestoreTheme');
export var GetThemeDetailWithUserInfo = getWrapper('themes')('GetThemeDetailWithUserInfo');
export var UpdateTheme = wrapper('themes')('UpdateTheme');
export var AddThemeOwner = wrapper('themes')('AddThemeOwner');
export var AddThemeColor = wrapper('themes')('AddThemeColor');
export var AddThemeColorItem = wrapper('themes')('AddThemeColorItem');
export var EditThemeColorItem = wrapper('themes')('EditThemeColorItem');
export var DeleteThemeColor = wrapper('themes')('DeleteThemeColor');
export var DeleteThemeColorItem = wrapper('themes')('DeleteThemeColorItem');
export var ResetThemeToVersion = wrapper('themes')('ResetThemeToVersion');
export var ClearTheme = wrapper('themes')('ClearTheme');
export var CreateTheme = wrapper('themes')('CreateTheme');
export var CreateThemeByThemeId = wrapper('themes')('CreateThemeByThemeId', {
  timeout: 60000
});
export var SaveToken = wrapper('tokens')('SaveToken', {
  messageError: false
});
export var ListTokens = wrapper('tokens')('ListTokens');
export var listDiffTokens = wrapper('tokens')('ListDiffTokens');
export var ResetTokens = wrapper('tokens')('ResetTokens');
export var SyncThemeFromOrigin = wrapper('themes')('syncThemeFromOrigin');
export var GetThemeDiff = wrapper('themes')('getThemeDiff');
export var ExecuteVersionBack = wrapper('rollback')('rollbackVersion', {
  timeout: -1
});